import type {LocalMediaKind} from '@phonehq/rtc-core';

export interface MediaUnavailableCopy {
    readonly title: string;
    readonly description: string;
}

export const mediaUnavailableCopy = (kinds: readonly LocalMediaKind[]): MediaUnavailableCopy => {
    const camera = kinds.includes('camera');
    const microphone = kinds.includes('microphone');
    const subject = camera && microphone ? 'Camera and microphone' : camera ? 'Camera' : 'Microphone';
    return {title: `${subject} unavailable`, description: 'Check browser permissions.'};
};
